import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useHover } from "@react-aria/interactions";
import { useFocusVisible } from "use-focus-visible";
import { keyCodes } from "../keyCodes";
import { StyledLi } from "./menuItem.styles";
import { PopupMenu } from "../popupMenu";
// utils
import { useIntersectionObserver } from "../../../utils/use-intersection-observer";
import { makeDataTestIdGetter } from "../../../utils";
export function MenuItemComponent({ popupMenu, name, onFocusPreviousMenuItem, onFocusNextMenuItem, onFocusNextPopupMenuItem, onFocusPreviousPopupMenuItem, isActive, isDisabled, onClick, onChange, index, setActiveItem, url, dataTestIdPrefix, }, ref) {
    var _a;
    const { hoverProps, isHovered } = useHover({
        onHoverStart: () => { },
        onHoverEnd: () => { },
    });
    const [isPressed, setIsPressed] = useState(false);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    useEffect(() => {
        if (!isActive)
            setIsPressed(false);
    }, [isActive]);
    const handleOnKeyDown = (e) => {
        switch (e.key) {
            case keyCodes.RETURN: {
                if (typeof onChange === "function") {
                    onChange();
                }
                break;
            }
            case keyCodes.DOWN: {
                onFocusNextPopupMenuItem();
                break;
            }
            case keyCodes.UP: {
                onFocusPreviousPopupMenuItem();
                break;
            }
            case keyCodes.LEFT: {
                onFocusPreviousMenuItem();
                break;
            }
            case keyCodes.RIGHT: {
                onFocusNextMenuItem();
                break;
            }
            case keyCodes.ESC: {
                const activeElement = document.activeElement;
                if (activeElement !== document.body)
                    activeElement.blur();
                break;
            }
            default: {
                break;
            }
        }
    };
    const { focusVisible, onFocus, onBlur } = useFocusVisible();
    const showPopup = isHovered || (isPressed && isActive) || focusVisible;
    const hasPopupArea = ((_a = popupMenu.popupMenuItems) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const entry = useIntersectionObserver(ref, {
        rootMargin: "0px -400px 0px 0px",
        threshold: 0.5,
    });
    const handleTouchEvents = (e) => {
        const { target } = e;
        const { current } = ref;
        if (!current.contains(target)) {
            setIsPressed(false);
        }
    };
    useEffect(() => {
        document.addEventListener("touchstart", handleTouchEvents);
        return () => document.removeEventListener("touchstart", handleTouchEvents);
    }, [ref]);
    return (_jsxs(StyledLi, Object.assign({ isDisabled: isDisabled }, hoverProps, { onKeyDown: handleOnKeyDown, onClick: (e) => {
            if (!isDisabled) {
                if (typeof onClick === "function") {
                    onClick();
                }
            }
            e.preventDefault();
        }, ref: ref, focusVisible: !isDisabled && focusVisible, onFocus: onFocus, onBlur: onBlur, isActive: isActive, role: "none", onTouchStart: (e) => {
            const { target } = e;
            const { current } = ref;
            if (!current.lastChild.contains(target)) {
                setIsPressed(true);
            }
        }, "data-testid": getDataTestId("menu-item-input") }, { children: [_jsx("a", Object.assign({ role: "menuitem", "aria-haspopup": hasPopupArea, "aria-expanded": showPopup, href: popupMenu.url, tabIndex: 0 }, { children: name })), hasPopupArea && (_jsx(PopupMenu, { openDirection: !entry || entry.isIntersecting ? "left" : "right", activeItemIndex: isActive ? popupMenu.activeItemIndex : -1, show: showPopup, popupMenuItems: popupMenu.popupMenuItems, ariaLabel: popupMenu.ariaLabel, mainMenuIndex: index, setActiveItem: setActiveItem, url: url }))] }), name));
}
export const MenuItem = React.forwardRef(MenuItemComponent);
